<template>

      <div class="rm" :ref="'rm_'+index">
        <div @click="selectRegistrationMethod(index)" class="rm-header row">
          <div class="row">
            <div class="col col-15 text-center"><input @input="selectRegistrationMethod(index)" class="input-radio" :id="'rm_'+index" name="rm" type="radio" :value="index"></div>
            <div class="col col-85">
              <label class="text-left" :for="'rm_'+index">
                <p class="mb-0 mt-0 lh-1-6"><strong>{{registration_method.name}}</strong></p>
                <p class="mb-0 mt-0 text-16 lh-1-6" v-if="this.generateDescription(registration_method)">{{this.generateDescription(registration_method)}}</p>
              </label>
            </div>
          </div>
        </div>
        <div class="rm-form p-30" v-if="selected==index">
          <!-- 2 = LN/RN Reg method, 7 = HTNG Member -->
          <div v-if="registration_method.registration_method_id==2 || registration_method.registration_method_id==7">
            
            <!-- If property is BOCA we have to add a dropdown to identify building and prepend code for PMS lookup,
                 if we have to do anything more with this in the future we will break out into custom template -->
            <select v-if="portal.property_id === 3341" class="input-text rounded mb-15" v-model="property_select.selected">
              <option disabled value="null">Please select building</option>
              <option v-for="option in property_select.options" :value="option.value" :key="option.value">
                {{ option.text }}
              </option>
            </select>   
            <p v-if="property_select.warn" style="font-size: 12px; color: white; background: #e25151; padding: 5px; border-radius: 5px;">Please Select Building</p>
            <!-- /BOCA --> 
                 
            <div class="row mb-15">
              <input v-model="form.last_name" class="input-text rounded" type="text" placeholder="Last Name (On Reservation)" />
            </div>
            <div class="row mb-15">
              <input v-model="form.room_number" class="input-text rounded" type="text" placeholder="Room Number" />
            </div>
          </div>
          <!-- Reg Method for 'Boca Member'-->
          <div v-if="registration_method.registration_method_id==9">
            <div class="row mb-15">
              <input v-model="form.member_number" class="input-text rounded" type="text" placeholder="Member Number" />
            </div>
          </div>
          <div v-if="registration_method.registration_method_id==3">
            <div class="row mb-15">
              <input v-model="form.email_address" class="input-text rounded" type="text" placeholder="Email" />
              <label class="text-left d-flex align-items-start" for="email_consent" v-if="portal.template.enable_email_consent">
                <input class="mr-10" id="email_consent" name="email_consent" type="checkbox" v-model="form.consent" />
                <!-- Terrible. If Amara do special consent text -->
                <span v-if="portal.property_id === 6084" class="text-16">Check this box. I’d like to receive exclusive offers and savings.  By clicking submit, I read and agree to the  <a href="https://www.amararesort.com/privacy-policy">Privacy Policy</a>.</span>
                <!-- Else normal for every other property -->
                <span v-else class="text-16">{{portal.template.consent_text}}</span>
              </label>
            </div>
          </div>
          <div v-if="registration_method.registration_method_id==4" class="row mb-15 p-rel">
            <input v-model="form.access_code" class="input-text rounded" type="text" placeholder="Access Code" />
            <span v-if="!access_code_valid" class="error-text">{{access_code_error_text}}</span>
          </div>
          <div class="mb-15">
            <button @click="emitRegistrationMethodData()" class="btn rounded" type="button" :style="'background: ' + color_background_button + '; color: ' + color_text_button">Continue</button>
          </div>
          <p class="text-center text-14 mb-0">
            By clicking continue you agree to the
            <button
              type="button"
              class="text-link"
              @click="selectTermsOfService(index)"
              :aria-expanded="selected_tos === index ? 'true' : 'false'"
              :aria-controls="`tos-panel-${index}`"
            >
              Terms and Conditions
            </button>
          </p>
          <div class="terms-of-service text-left pt-20" v-if="selected_tos==index">
            <div v-html="registration_method.terms_of_service"></div>
            <div class="mt-30 text-center"><button class="btn-close" @click="selectTermsOfService(null)">CLOSE</button></div>
          </div>
        </div>
      </div> <!-- rm -->



</template>
<script>
export default {
  name: 'registration_method',
  props: ['index','portal','selected','selected_tos','color_background_button','color_text_button','registration_method'],
  data(){
    return{
      // access_code: null,
      access_code_valid: true,
      access_code_error_text: 'Required',
      clicked: false,
      property_select: {
        selected: null,
        warn: false,
        room_number_pms: '',
        options: [
          { text: 'Cloister', value: 'C' },
          { text: 'Yacht Club', value: 'Y' },
          { text: 'Tower', value: 'T' },
          { text: 'Beach Club', value: 'B' },
          { text: 'Bungalows', value: 'R' }
        ]
      },
      form: {
        access_code: null,
        last_name: '',
        room_number: '',
        email_address: '',
        club_code: null,
        member_number: '',
        consent: false,
        optin_default: 0
      },
    }
  },
  watch: {
    'selected':function(){
      this.$el.querySelector( '#rm_' + this.index ).checked = (this.selected == this.index);
    }
  },
  mounted(){
    this.$el.querySelector( '#rm_' + this.index ).checked = (this.selected == this.index);
    this.form.consent = this.portal.template.optin_default
  },
  methods: {
    // Generate the description that appears below the Registration Method name
    generateDescription:function(rm){
      if(rm.type!='rateplan') return null;

      // return the custom rate plan description if set on the rate plan
      if(rm.rate_plan_description) return rm.rate_plan_description

      var description = '';
      if (parseInt(rm.price)==0) {
        description += 'Connect';
      } else {
        description += '$' + rm.price;
      }

      description += ' for ';

      if(rm.duration>=1440){
        if(rm.duration % 1440 > 0){
          description += ' more than ';
        }
        var whole_days = Math.floor(rm.duration / 1440);
        description += whole_days + ' day'
        if(whole_days > 1){
          description += 's';
        }
      } else if(rm.duration>=60){
        if(rm.duration % 60 > 0){
          description += ' more than ';
        }
        var whole_hours = Math.floor(rm.duration / 60);
        description += whole_hours + ' hour'
        if(whole_hours > 1){
          description += 's';
        }
      } else {
        description += rm.duration + ' minute'
        if(rm.duration > 1){
          description += 's';
        }
      }

      description += ' with ';
      if(rm.additional_devices>0){
        //It needs to include the original device plu the additional devices
        description += 'up to ' + (rm.additional_devices+1) + ' devices';
      } else {
        description += '1 device';
      }
      if(rm.speed_upload && rm.speed_download){
        description += ' (' + rm.speed_upload + ' Up / ' + rm.speed_download + ' Down)';
      }
      return description;
    },
    // Send selected Registration Method back to parent
    selectRegistrationMethod:function(index){
      this.$emit('changeSelected', index);
    },
    // Send selected Terms of Service back to parent
    selectTermsOfService:function(index){
      this.$emit('changeSelectedTOS', index);
    },
    // Manipulate and send registration method data back to parent
    emitRegistrationMethodData:function(){
      if(this.registration_method.type=='accesscode' && !this.form.access_code.trim()){
        this.access_code_valid = false;
        return;
      } else if(this.registration_method.registration_method_id==3 && !this.form.email_address.trim()) {
        return;
      } else if( (this.registration_method.registration_method_id==2 || this.registration_method.registration_method_id==7) && (!this.form.last_name.trim() || !this.form.room_number.trim() )) {
        return;
      }

      let room_number_final = this.form.room_number

      // BOCA property transforms, stupid but fast
      if(this.portal.property_id === 3341) {
        //set the standard BOCA club code
        this.form.club_code = '47'
        // check for selected building code to prepend to room number
        // if not selected 'warn' frontend and don't submit
        if (this.property_select.selected === null) {
          // turn on warn
          this.property_select.warn = true
          // cancel form
          return; 
        } else {
          // turn off warn if on and proceed
          this.property_select.warn = false
          room_number_final = this.property_select.selected + this.form.room_number
        }
      }

      if(this.clicked) return;
      this.clicked = true;



      const emitted = {
        registration_method_id: this.registration_method.registration_method_id,
        rateplan_id: this.registration_method.id,
        ...(!!this.form.last_name && { last_name: this.form.last_name } ),
        ...(!!this.form.first_name && { first_name: this.form.first_name } ),
        ...(!!this.form.room_number && { room_number: room_number_final } ),
        ...(!!this.form.email_address && { email_address: this.form.email_address } ),
        ...(!!this.form.club_code && { club_code: this.form.club_code } ),
        ...(!!this.form.member_number && { member_number: this.form.member_number } ),
        ...(!!this.form.access_code && { access_code: this.form.access_code } ),
        ...(this.form.consent && { email_opt_in: 1 } ),
      }

      this.$emit('emitRegistrationMethodData', emitted);
    },

  }
}
</script>
<style>

.rm a, .rm span.text-link { color: #000000; text-decoration: underline; cursor: pointer }
.rm .help-text { color: #000000; padding: 5px 0; font-size: 14px; font-style: italic; text-align: center; display: block; }
.rm .error-text { text-transform: uppercase; position: absolute; line-height: 1; right: 12px; top: 12px; padding: 8px 8px 7px 8px; background: red; color: #ffffff; border-radius: 3px; text-align: left; font-weight: bold; font-size: 12px; }
.rm .rm-header { background: #ffffff; border-top-width: 1px; border-top-style: solid; cursor: pointer; }
.rm .rm-form { background: #eeeeee; border-top-width: 1px; border-top-style: solid; }
.rm:last-child { border-bottom-width: 1px; border-bottom-style: solid; }
.rm .input-text { border: 1px solid #cccccc; color: #000000; overflow: visible;width: 100%;padding: 15px; font-size: 16px;}
.rm .input-text.rounded { border-radius: 6px; }
.rm .btn { background: #ffffff; border: 1px solid rgba(0,0,0,0.3); background: rgb(252,252,252); background: -moz-linear-gradient(top, rgba(252,252,252,1) 0%, rgba(232,232,232,1) 100%); background: -webkit-linear-gradient(top, rgba(252,252,252,1) 0%,rgba(232,232,232,1) 100%); background: linear-gradient(to bottom, rgba(252,252,252,1) 0%,rgba(232,232,232,1) 100%); filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#fcfcfc', endColorstr='#e8e8e8',GradientType=0 ); }
.rm .btn { width: 100%; padding: 20px; cursor: pointer; font-size: 20px; font-weight: bold; }
.rm .btn.rounded { border-radius: 6px; }
.rm label { display: inline-block; padding: 10px 30px 10px 0px; width: 100%; font-size: 18px; }
.rm label span { font-size: 16px; font-weight: normal; }
.rm .input-radio { display: inline-block; padding: 10px; }

button.text-link {border: none; background: none; cursor: pointer; text-decoration: underline; padding:0; margin: 0;}
</style>
